import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EventsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor( private http: HttpClient ) { }

  public getAlerts(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_listCenterAlert', item, options);
  }
  public getAlertsCounter(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/centerMaintenance/centerAlert/count', options);
  }

  public getAlertInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_getCenterAlert', item, options);
  }

  public getAlertApplications(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_listOfCenterAlertApplications', item, options);
  }

  public getCompanyMailProviders(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_getCompanyMailConfigList', item, options);
  }

  public addNewAlert(context, lang, udid, active, alertName, centerInternalId, centerAlertDeviceList, centerAlertContacts, centerAlertApplications, iotDevices, centerAlertCapacityList, companyMailConfig) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { active, alertName, centerInternalId, centerAlertDeviceList, centerAlertContacts, centerAlertApplications, iotDevices, centerAlertCapacityList, companyMailConfig };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_saveCenterAlert', item, options);
  }

  public updateAlertStatus(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_changeCenterAlertStatus', item, options);
  }

  public updateAlertInfo(context, lang, udid, internalId, active, alertName, centerInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active, alertName, centerInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_saveCenterAlert', item, options);
  }

  public updateAlertContacts(context, lang, udid, internalId, centerAlertContacts) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, centerAlertContacts };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_updateAlertContacts', item, options);
  }

  public updateAlertAlertTypes(context, lang, udid, internalId, centerAlertDeviceList) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, centerAlertDeviceList };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/alerts/updateAlertTypes', item, options);
  }

  public updateAlertApplications(context, lang, udid, internalId, centerAlertApplications) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, centerAlertApplications };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/alerts/updateApplications', item, options);
  }

  public updateAlertIotDevices(context, lang, udid, internalId, iotDevices) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, iotDevices };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/alerts/updateIotDevices', item, options);
  }

  public updateAlertCapacityList(context, lang, udid, internalId, centerAlertCapacityList) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, centerAlertCapacityList };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_updateAlertOccupation', item, options);
  }

  public updateAlertMailConfigProvider(context, lang, udid, internalId, companyMailConfig) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, companyMailConfig };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_updateMailConfigProvider', item, options);
  }

  public deleteAlert(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/centerMaintenance/ws_deleteCenterAlert', item, options);
  }
}
